import { useApi } from '~/composables/useApi';

const buildParams = (params: Record<string, string | number>) => {
  const body = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v === '' || v == null) return;
    body.append(k, String(v));
  });
  return body.toString();
};

export const useQnaBoardApi = () => {
  const fetchBoardList = (params: Record<string, string | number>) => {
    return useApi('/api/system/system/board/boardList_json.do', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: buildParams(params),
    });
  };

  const fetchBoardDetail = (params: Record<string, string | number>) => {
    return useApi('/api/comPop/system/system/board/selectBoardDetail_json.do', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: buildParams(params),
    });
  };

  return {
    fetchBoardList,
    fetchBoardDetail,
  };
};
